import React, { FC } from "react";

interface AboutType {
    aboutTitle?: string;
    aboutContent?: string;
    aboutLogo?: string;
}
const About: FC<AboutType> = ({ aboutContent, aboutTitle, aboutLogo }) => {
    return (
        <section className="about">
            <div className="flex gap-2">
                <div className="">
                    <img src={aboutLogo} alt="" />
                </div>
                <div className="mt-2">
                    <h2 className="m-0 about-text">About</h2>
                    <h3 className="m-0 about-header">{aboutTitle}</h3>
                </div>
            </div>
            <p className="content">{aboutContent}</p>
        </section>
    );
};

export default About;
